import { Form } from 'factorial-form'

export interface CopyPeriodParams {
  start_at: string
  end_at: string
  destination_start_at: string
}

class CopyPeriodForm extends Form {
  constructor(values: CopyPeriodParams) {
    super(values, {
      start_at: 'string',
      end_at: 'string',
      destination_start_at: 'string',
    })
  }
}

export default CopyPeriodForm
